import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { centralizedHost } from "~/Utils";

interface DocumentDetailsResponse {
  id: number;
  name_mandarin: string;
  name_malay: string;
  name: string;
  published: string;
  slug: string;
  myairports_airport_label: string;
  latitude: string;
  longitude: string;
  radius: string;
}

const fetchCentralizedModulesDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await axios.get(`${centralizedHost}/api/project-airport-ecms/${id}`);
  return response.data[0];
};

const useCentralizedModulesDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["centralizedModules", id],
      enabled: false,
      queryFn: () => {
        return fetchCentralizedModulesDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useCentralizedModulesDetails };
